export default function HeroSection() {
  return (
    <section id="heroSection" className="hero--section">
      <div className="hero--section--content--box">
        <div className="hero--section--content">
          <p className="section--title">Ayoze Jesús León Santos</p>
          <h1 className="hero--section--title">
            <span className="hero--section-title--color">Full Stack</span>{" "}
            <br />
            Developer
          </h1>
          <p className="hero--section-description">
            ¿Estas buscando un desarrollador Full Stack para tu empresa o una
            colaboración en un proyecto? ¡Estás en el lugar correcto!
          </p>
        </div>
        <a href="/curriculum.pdf" download className="btn btn-primary">
          Descargar Currículum
        </a>
      </div>
      <div className="hero--section--img">
        <img src="./img/image-perfil.png" alt="Hero Section" />
      </div>
    </section>
  );
}
